export const other_labels_de = {
  find_your_muni: 'Finden Sie Ihre Gemeinde',
  find_your_muni_lead:
    'Wollen Sie wissen, ob die Armen und Reichen in Ihrer Gemeinde voneinander getrennt oder vielmehr durchmischt leben? Hier gehts zu unserem interaktiven Tool: ',
  search_muni: 'Gemeinde suchen',
  no_muni_selected: 'Keine Gemeinde ausgewählt',
  neib_muni: 'Angrenzende Gemeinden',
  histo_title: 'Die gesellschaftlichen Schichten in',
  histo_info:
    'Die folgende Grafik zeigt, wie die Verteilung von privilegierten und weniger privilegierten Menschen in Ihrer Gemeinde im Vergleich zum schweizerischen Durchschnitt aussieht.',
  histo_labels: [
    'Schweizer Durchschnitt',
    'Sozioökonomischer Status',
    'Anteil an der Bevölkerung',
  ],
  poor: 'Ärmer',
  rich: 'Reicher',
  poor_first: 'Tiefer Status (Ärmer)',
  rich_first: 'Hoher Status (Reicher)',
  sat_title: 'Satellitenbilder zeigen die geteilten Lebenswelten',
  chmaptitle: 'Sozioökonomischer Status in der Schweiz',
  histo_text: (
    <>
      <p>
        Die Balken unterteilen den sozioökonomischen Index (0 bis 100 Punkte) in
        20 Gruppen. Je höher der Indexwert, desto höher ist der Status und desto
        reicher sind folglich die Leute. Für die Grafik heisst das: je weiter
        rechts, desto reicher; je weiter links, desto ärmer.
      </p>
      <p>
        Die Höhe der Balken gibt den Prozentsatz der Leute in der jeweiligen
        Gruppe an. Je stärker Ihre Gemeinde den Schweizer Durchschnitt rechts
        überlappt, desto mehr wohlhabende Leute wohnen in Ihrer Gemeinde. Und je
        weiter links Ihre Gemeinde den Durchschnitt überlappt, desto mehr ärmere
        Leute wohnen in Ihrer Gemeinde.
      </p>
    </>
  ),
  map_labels: [
    'In den Gemeinden am Zürichsee leben viele Privilegierte',
    'Bevorzugte Wohnlagen am Genfersee',
    'In den Alpentälern sind die Menschen weniger wohlhabend',
    'In Randregionen wie dem Emmental und Entlebuch ist der soziale Status vergleichsweise tief',
  ],
  source:"Quelle: Institute of Social and Preventive Medicine, University of Bern"
}


